// Default backend URL:  This gets used when client code
// doesn't call the function setBackendURL function below.
let backendUrl = "http://localhost:5000"
let facilitatorUrl = "http://no-url-defined";

export function setBackendURL(url) {
  if (!url || url.length === 0) {
    console.error("Skipping url adjustment. Function \"setBackendURL\" was called with an empty url.");
    return;
  }

  console.log("Using backend at: ", url)
  backendUrl = url;
}

export function getBackendURL() {
  return backendUrl;
}



export function setFacilitatorAppURL(url) {
  if (!url || url.length === 0) {
    console.error("Skipping url adjustment. Function \"setFacilitatorAppURL\" was called with an empty url.");
    return;
  }

  console.log("Using backend at: ", url)
  facilitatorUrl = url;
}


export function getFacilitatorAppURL() {
  return facilitatorUrl;
}